import { Money, decodeMoneyWire } from '@klear/money'

export function parseUnsafeMoney(value: string | null | undefined): Money | null {
  if (value == null || value.trim() === '') return null
  const decoded = decodeMoneyWire(value.trim())
  return decoded === undefined ? null : Money.fromMinorUnits(decoded.amount, decoded.currency)
}

export function formatUnsafeMoney(value: string | null | undefined): string | null {
  return parseUnsafeMoney(value)?.toString() ?? null
}
